import React from "react";
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import { Layout } from "antd";
// import {  isBrowser } from "react-device-detect";
import FeaturedPage from "./FeaturedPage";
import Navbar from "./Navbar";
import ProjectListPage from "./ProjectListPage";
// import ContactMe from "./ContactMe";
import "./style.css";
import DetailPage from "./DetailPage";
import { ToastContainer } from "react-toastify";

const IngPortoApp = () => {
  console.log(window.innerWidth)
  const { Footer } = Layout;
  // if (isBrowser) {
    return (
        <Layout>  
        <ToastContainer />
          <Navbar/>
          <Routes>
            {/* <Route path="/" element={<Navigate to="/" />} /> */}
            <Route path="/" element={<FeaturedPage />}/>
            <Route exact path="/project/" 
            element={<ProjectListPage />}
            // element={<Navigate to="/project/details" />}
            />

          </Routes>
          <Footer style={{ textAlign: "center" }}>
            <strong>InDesign CREATION ©2022 </strong>
          </Footer >
        </Layout>
    );
};

export default IngPortoApp;
